import React from "react";
import { Link } from "gatsby";
import { BaseTile } from "../../shared/molecules";

const GatsbyBaseTile = (props) => {
  return <BaseTile internalLinkComponent={Link} {...props} />;
};

export default GatsbyBaseTile;
